import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

const DeleteItemModal = ({ open, onClose, itemName, onConfirm }) => (
  <Dialog open={open} onClose={onClose} dir="rtl" fullWidth maxWidth="xs">
    <DialogTitle>تأیید حذف آیتم</DialogTitle>
    <DialogContent>
      <Typography>{itemName ? `«${itemName}» از پیش‌نویس منو حذف شود؟` : "این آیتم از پیش‌نویس منو حذف شود؟"}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>حذف نهایی پس از ذخیره منو انجام می‌شود.</Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>انصراف</Button>
      <Button color="error" onClick={() => { onConfirm(); onClose(); }}>حذف</Button>
    </DialogActions>
  </Dialog>
);

export default DeleteItemModal;
